import ModelColorItemInterface from "../../../interfaces/model/ModelColorItemInterface";
import {useEffect, useState} from "react";
import {FilterColorInterface} from "../../../interfaces/catalog/FilterColorInterface";
import {FilterSuperCategoryInterface} from "../../../interfaces/catalog/FilterSuperCategoryInterface";
import {SelectedFiltersInterface} from "../../../interfaces/catalog/SelectedFiltersInterface";
import {useLocation, useSearchParams} from "react-router-dom";
import ModelPropertyFilterInterface from "../../../interfaces/model/ModelPropertyFilterInterface";
import {SortType} from "./Sort";
import useUrlFilterConvertor from "./useUrlFilterConvertor";
import 'simplebar-react/dist/simplebar.min.css';
import ModelCategoryInterface from "../../../interfaces/model/ModelCategoryInterface";
import PropertyFilters from "./filters/PropertyFilters";
import CategoryFilters from "./filters/CategoryFilters";
import PriceFilters from "./filters/PriceFilters";
import SuperCategoryFilters from "./filters/SuperCategoryFilters";
import SizeFilters from "./filters/SizeFilters";
import ColorFilters from "./filters/ColorFilters";
import { useCatalogFilters } from "./filters/useCatalogFilters";

declare var $: any;

export default function Filters({
                                    isOpen,
                                    setIsOpen,
                                    modelColorItems,
                                    superCategories,
                                    categories,
                                    selectedFilters,
                                    setSelectedFilters,
                                    properties
                                }:
                                    {
                                        isOpen: boolean,
                                        setIsOpen: Function,
                                        modelColorItems: ModelColorItemInterface[],
                                        superCategories: FilterSuperCategoryInterface[],
                                        categories: ModelCategoryInterface[],
                                        selectedFilters: SelectedFiltersInterface,
                                        setSelectedFilters: (selectedFilters: SelectedFiltersInterface) => void,
                                        properties: ModelPropertyFilterInterface[]
                                    }) {

    const [selectedSizes, setSelectedSizes] = useState<string[]>([])
    const [selectedColors, setSelectedColors] = useState<FilterColorInterface[]>([])
    const [selectedSuperCategories, setSelectedSuperCategories] = useState<FilterSuperCategoryInterface[]>([])
    const [selectedCategories, setSelectedCategories] = useState<ModelCategoryInterface[]>([])
    const [selectedProperties, setSelectedProperties] = useState(new Map<number, string[]>())
    const [isFilterSelected, setIsFilterSelected] = useState(false)
    const [activeFolders, setActiveFolders] = useState<string[]>([])
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [fromPrice, setFromPrice] = useState(0)
    const [toPrice, setToPrice] = useState(0)

    const [searchParams, setSearchParams] = useSearchParams();
    const {convertFromUrl, filterFields} = useUrlFilterConvertor(selectedFilters, [], SortType.RAITING)
    const { 
        getUniqueColors, 
        getUniqueSizes, 
        getFilteredSuperCategories, 
        getInitPriceRange,
        addColor,
        removeColor,
        addSize,
        removeSize,
        addSuperCategory,
        removeSuperCategory,
        addCategory,
        removeCategory,
        addProperty,
        setProperties,
        removeProperty
    } = useCatalogFilters(
        modelColorItems, 
        superCategories,
        selectedColors,
        setSelectedColors,
        selectedSizes,
        setSelectedSizes,
        selectedSuperCategories,
        setSelectedSuperCategories,
        selectedCategories,
        setSelectedCategories,
        selectedProperties,
        setSelectedProperties
    )

    const location = useLocation();

    const applyFilters = () => {
        setIsOpen(false)
    }

    const resetFilters = () => {
        setSelectedSizes([])
        setSelectedColors([])
        setSelectedSuperCategories([])
        setSelectedCategories([])
        setFromPrice(getInitPriceRange().min)
        setToPrice(getInitPriceRange().max)
        setSelectedProperties(new Map())
        applyFilters()

        filterFields().map(field => {
            searchParams.delete(field)
        })

        selectedProperties.forEach((value, key) => {
            searchParams.delete('prop_' + key)
        })

        setSearchParams(searchParams)
    }

    const applyPriceRqange = () => {
        $('.js-one-price-slider').ionRangeSlider({
            skin: "round",
            type: "double",
            from: getInitPriceRange().min,
            to: getInitPriceRange().max,
            min: getInitPriceRange().min,
            max: getInitPriceRange().max,
            onFinish: (slider: any) => {
                setFromPrice(slider.from)
                setToPrice(slider.to)
            }
        });


        // $('.scrollbar-inner').scrollbar({"scrollx": "advanced", "scrolly": "advanced"});
    }



    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!modelColorItems.length) return

        if (!location.search) return

        const paramsFromFilters = convertFromUrl(searchParams.toString())

        paramsFromFilters.map(item => {

            if (item.name === 'supercategory' && superCategories?.length) {
                const superCategoriesFromParams = superCategories.filter(superCategory => item.value.indexOf('' + superCategory.id) > -1)
                setSelectedSuperCategories(superCategoriesFromParams)
                setActiveFolders([...activeFolders, 'supercategory'])
            }

            if (item.name === 'category' && categories?.length) {
                const categoriesFromParams = categories.filter(category => item.value.indexOf('' + category.id) > -1)
                setSelectedCategories(categoriesFromParams)
                setActiveFolders([...activeFolders, 'category'])
            }

            if (item.name === 'price') {
                const [from, to] = item.value

                if (from) {
                    setFromPrice(parseInt(from))
                }
                if (to) {
                    setToPrice(parseInt(to))
                }
            }

            if (item.name === 'size') {
                setSelectedSizes(item.value)
            }

            if (item.name === 'color') {
                setSelectedColors(getUniqueColors().filter(color => item.value.indexOf(color.color) > -1))
            }

            if (item.id) {
                setProperties(item.id, item.value)
                setActiveFolders([...activeFolders, 'prop' + item.id])
            }
        })

    }, [searchParams, modelColorItems.length]);

    useEffect(() => {
        if (!location.search) {
            resetFilters()
        }
    }, [location.pathname]);


    const maxPrice = getInitPriceRange().max

    useEffect(() => {
        const handleScrollLock = () => {
            if (isOpen && window.innerWidth <= 991) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        };

        handleScrollLock();
        window.addEventListener('resize', handleScrollLock);

        return () => {
            window.removeEventListener('resize', handleScrollLock);
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        if (maxPrice) {
            if(!searchParams.get('price')){
                setFromPrice(getInitPriceRange().min)
                setToPrice(getInitPriceRange().max)
            }
            applyPriceRqange()
        }

    }, [maxPrice]);



    useEffect(() => {
        setSelectedFilters({
            colors: selectedColors,
            sizes: selectedSizes,
            superCategories: selectedSuperCategories,
            priceRange: fromPrice > getInitPriceRange().min || toPrice < getInitPriceRange().max ? {
                from: fromPrice,
                to: toPrice
            } : null,
            categories: selectedCategories,
            properties: selectedProperties
        })

        setIsFilterSelected(selectedSizes.length > 0 || selectedColors.length > 0 || selectedSuperCategories.length > 0 || selectedCategories.length > 0 || fromPrice > getInitPriceRange().min || toPrice < getInitPriceRange().max || selectedProperties.size > 0)
    }, [selectedSizes, selectedColors, fromPrice, toPrice, selectedSuperCategories, selectedCategories, selectedProperties])



    return (<div className={"all-filters 100vh-fix " + (isOpen && 'active')}>
        <div className="head">
            <div className="f-exp all-filters-title">Фильтры</div>
            <i className="close ico ico-close pointer" onClick={() => {
                setIsOpen(false)
            }}></i>
        </div>
        <div className="body">

                <div className="scrollbar-inner">
                    {/*<SuperCategoryFilters*/}
                    {/*    superCategories={getFilteredSuperCategories()}*/}
                    {/*    selectedSuperCategories={selectedSuperCategories}*/}
                    {/*    addSuperCategory={addSuperCategory}*/}
                    {/*    removeSuperCategory={removeSuperCategory}*/}
                    {/*/>*/}

                    <CategoryFilters
                        categories={categories}
                        selectedCategories={selectedCategories}
                        addCategory={addCategory}
                        removeCategory={removeCategory}
                    />

                    <PriceFilters
                        modelColorItems={modelColorItems}
                        fromPrice={fromPrice}
                        toPrice={toPrice}
                        setFromPrice={setFromPrice}
                        setToPrice={setToPrice}
                        getInitPriceRange={getInitPriceRange}
                    />

                    <PropertyFilters
                        properties={properties}
                        selectedProperties={selectedProperties}
                        addProperty={addProperty}
                        removeProperty={removeProperty}
                        includePropertyId={[1]}
                    />

                    <SizeFilters 
                        selectedSizes={selectedSizes}
                        getUniqueSizes={getUniqueSizes}
                        addSize={addSize}
                        removeSize={removeSize}
                    />

                    <ColorFilters
                        selectedColors={selectedColors}
                        getUniqueColors={getUniqueColors}
                        addColor={addColor}
                        removeColor={removeColor}
                    />

                    <PropertyFilters 
                        properties={properties}
                        selectedProperties={selectedProperties}
                        addProperty={addProperty}
                        removeProperty={removeProperty}
                        excludePropertyId={[1]}
                    />
                </div>

        </div>
        {isFilterSelected && <div className="btns">
            <a className="btn btn-secondary" href="/" onClick={(event) => {
                event.preventDefault()
                applyFilters()
            }}>Применить</a>
            <a className="btn  btn-outline-secondary" href="/" onClick={(event) => {
                event.preventDefault()
                resetFilters()
            }}>Сбросить</a>
        </div>}
    </div>)
}